import { ChangeEvent } from "react";

export type InputChangeUnion =
  | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  | string;

export enum FormFieldVariants {
  PRIMARY = "primary",
}
